<template>
  <ul class="form-item-list">
    <li>
      <h3>납부 정보를 입력해주세요</h3>
    </li>
    <li>
      <element-textbox
        v-model="formData.자동이체은행명.value"
        :error="formData.자동이체은행명.error"
        :label="formData.자동이체은행명.label"
        :placeholder="formData.자동이체은행명.placeholder"
      />
    </li>
    <li>
      <element-textbox
        v-model="formData.계좌번호.value"
        :error="formData.계좌번호.error"
        :label="formData.계좌번호.label"
        :placeholder="formData.계좌번호.placeholder"
      />
    </li>
    <li>
      <element-select
        v-model="formData.자동이체일.value"
        :error="formData.자동이체일.error"
        :label="formData.자동이체일.label"
        :items="formData.자동이체일.items"
        :placeholder="formData.자동이체일.placeholder"
      />
      <h5 style="color: #787878; margin-top: 5px;">MG : 5/10/15/20/25/말일, KB: 5/10/15/20/25, DB: 5/11/15/21, 현대: 5/10/20/25, 삼성: 5/13/15/23/25, 메리츠: 5/11/15/21/25, 한화: 5/11/15/21/25, 롯데: 5/10/15/20/25, 라이나: 10/15/25/말일, 흥국: 5/10/15/20/25일</h5>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Payment',
  props: ['formData'],
  data() {
    return {
    }
  },
  watch: {
    'formData.자동이체은행명.value': function (n) {
      this.update('자동이체은행명', n);
    },
    'formData.계좌번호.value': function (n) {
      const num = n.replace(/\D/g, '');
      this.formData.계좌번호.value = num;
      this.update('계좌번호', num);
    },
    'formData.자동이체일.value': function (n) {
      this.update('자동이체일', n);
    },
  },
  created() {
    for (let i = 1; i < 31; i++) {
      this.formData.자동이체일.items.push({ value: i, label: `${i}일` });
    }
    this.formData.자동이체일.items.push({ value: '매월말일', label: '매월말일' });
  },
  methods: {
    update(type, value) {
      if (value !== '') {
        this.$emit('update', { type, value });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
  .detail-form {
    h3 {
      margin-bottom: 2*$unit;
    }
    .el-row {
      margin-bottom: 2*$unit;

      &.my-1 {
        margin-bottom: $unit;
      }
      .mx-0 {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: $unit;
      }
      .el-input {
        height: 54px;

        & ::-webkit-input-placeholder { text-align:right; }
        & input:-moz-placeholder { text-align:right; }
  
        .el-input__inner {
          height: 54px;
          border-radius: 0;
        }
  
        .el-input__suffix-inner {
          line-height: 54px;
          color: #000;
        }
      }
    }
  }
}
</style>